<script setup>
import { computed } from 'vue'
import { useI18n } from '../../i18n.js'

const props = defineProps({ modelValue: { type: String, default: 'ALL' }, label: { type: String, required: true },
  state: { type: Object, required: true }, optionValue: { type: Function, required: true }, optionLabel: { type: Function, required: true },
  staticOptions: { type: Array, default: () => [] }, disabled: Boolean, selectDisabled: Boolean, searchable: Boolean,
  searchHint: { type: String, default: '' }, moreLabel: { type: String, default: '' }, firstLabel: { type: String, default: '' } })
const emit = defineEmits(['update:modelValue', 'load', 'search', 'select'])
const { t } = useI18n()
const displayed = computed(() => {
  const page = props.state.items
  const selected = props.state.selected
  return selected && props.optionValue(selected) === props.modelValue && !page.some((item) => props.optionValue(item) === props.modelValue)
    ? [selected, ...page] : page
})
function select(value) {
  emit('select', displayed.value.find((item) => props.optionValue(item) === value) ?? null)
  emit('update:modelValue', value)
}
</script>

<template>
  <div class="pts2-paged-filter">
    <label><span>{{ label }}</span>
      <input v-if="searchable" :value="state.search" type="search" maxlength="80" autocomplete="off"
        :aria-label="t('pts2FilterSearch', { label })" :placeholder="searchHint || t('pts2FilterSearch', { label })"
        :disabled="disabled" @input="emit('search', $event.target.value)" @keydown.enter.prevent>
      <select :value="modelValue" :aria-label="label" :disabled="disabled || selectDisabled || state.loading || Boolean(state.error)"
        @focus="emit('load', undefined)" @change="select($event.target.value)">
        <option v-for="option in staticOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
        <option v-if="modelValue !== 'ALL' && !staticOptions.some((item) => item.value === modelValue) && !displayed.some((item) => optionValue(item) === modelValue)" :value="modelValue">{{ t('pts2FilterSelected') }}</option>
        <option v-for="option in displayed" :key="optionValue(option)" :value="optionValue(option)">{{ optionLabel(option) }}</option>
      </select>
    </label>
    <small v-if="state.loading" role="status">{{ t('pts2FilterOptionsLoading') }}</small>
    <small v-else-if="state.error" class="field-error" role="alert">{{ t(state.error) }}</small>
    <small v-else-if="!state.items.length">{{ t('pts2FilterOptionsEmpty') }}</small>
    <div class="pts2-alert-option-actions">
      <button v-if="state.error" class="pc-secondary" type="button" :disabled="disabled || state.loading" @click="emit('load', state.requestedCursor, true)">{{ t('pts2FilterRetry') }}</button>
      <button v-if="state.nextCursor" class="pc-secondary" type="button" :disabled="disabled || state.loading" @click="emit('load', state.nextCursor)">{{ moreLabel || t('pts2FilterMore') }}</button>
      <button v-if="state.requestedCursor" class="pc-secondary" type="button" :disabled="disabled || state.loading" @click="emit('load', null)">{{ firstLabel || t('pts2FilterFirst') }}</button>
    </div>
  </div>
</template>
